import { render, staticRenderFns } from "./CompDBGeneList.vue?vue&type=template&id=b59c3012&"
import script from "./CompDBGeneList.vue?vue&type=script&lang=js&"
export * from "./CompDBGeneList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports